import { CQ_ACTION_CODES } from '../../../catalogConstants';
import { STRING_KEYS } from '../../common';
import { USER_TYPE } from '../../../bitConstants/constants';

export const localizedStrings = {
  common: {
    everyMainSelection: {
      [STRING_KEYS.stepTitles.mainAction]: 'Indica cómo quieres configurar esta tarifa',
      [STRING_KEYS.se.risk.subject]: 'TELCOBI - ERROR TELCO RIESGO TARIFAS NO AT',
      [STRING_KEYS.payment.step.insertDirectDebitSecondaryText]: 'Es necesario asociar una cuenta bancaria por si realizas algún consumo adicional que no esté incluido en tu tarifa',
      [STRING_KEYS.payment.step.chooseDirectDebitSecondaryText]: 'Es necesario asociar una cuenta bancaria por si realizas algún consumo adicional que no esté incluido en tu tarifa',
      [STRING_KEYS.shipment.text]: 'Recibirás La tarjeta SIM en un plazo de 48h en la dirección que nos indiques.',
      [STRING_KEYS.shipment.secondaryText]: '',
      [STRING_KEYS.process.title]: 'Quiero activar mi línea móvil',
      [STRING_KEYS.summary.title]: 'Quiero activar mi línea móvil',
      [STRING_KEYS.summary.mobileLineAction.title]: 'Línea móvil',
      [STRING_KEYS.summary.mobileLineAction.multipleActionsTitle]: 'Líneas móviles',
      [STRING_KEYS.summary.activationCard.image]: 'https://prod.adb.col.movistar.es/content/dam/movistar/estaticos/img/mano-movil.png',
      [STRING_KEYS.summary.activationCard.title]: 'Confirma la activación',
      [STRING_KEYS.summary.activationCard.description]: 'Revisa tus datos y completa la activación',
      [STRING_KEYS.summary.shipment.title]: 'Envío SIMs',
      [STRING_KEYS.summary.shipment.text]: 'Recibirás la tarjeta SIM en un plazo de 48h.',
      [STRING_KEYS.summary.shipment.secondaryText]: '',
      [STRING_KEYS.legalNSubmit.buttonText]: 'Activar',
      [STRING_KEYS.confirmation.subtitle]: 'Puedes hacer seguimiento del pedido en tu área privada.',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
      [STRING_KEYS.summary.mainActionSelected.value]: 'Número nuevo',
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
      [STRING_KEYS.summary.mainActionSelected.value]: 'Portabilidad: {phoneNumber}',
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
      [STRING_KEYS.summary.mainActionSelected.value]: '{phoneNumber}',
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
      [STRING_KEYS.summary.secondaryAction[CQ_ACTION_CODES.REGISTER]]: 'Número nuevo',
      [STRING_KEYS.summary.secondaryAction[CQ_ACTION_CODES.PORTABILITY]]: 'Portabilidad: ',
      [STRING_KEYS.summary.secondaryAction[CQ_ACTION_CODES.MIGRATION]]: '',
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.TELCO}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.OPEN}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
}
